export enum ToggleCompanyStatusEnum {
    Nda = 0,
    Bid = 1,
    RevokeAllAccess = 2,
    BulkDownload
}